export default __webpack_public_path__ + "assets/Playa_Del_Carmen.1a59ef91.png";